<template>
  <component :is="component" />
</template>

<script>
import salePlanChangeCheck from '../components/salePlanChangeCheck.vue'
import salePlanChangeEdit from '../salePlanChangeEdit.vue'
export default {
  components: {
    salePlanChangeCheck,
    salePlanChangeEdit
  },
  data() {
    return {
      component: 'salePlanChangeCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'salePlanChangeCheck' : 'salePlanChangeEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/check/salePlanChangeCheck.vue